import axios from "axios";


class NotificationService {
    getNotifications() {
        return axios.get('notification/')
    }

    getCountNotification() {
        return axios.get('count_notification/')
    }

}

export default new NotificationService()